import { useEffect, useState } from 'react';
import CourseCard from '../../components/home/CoursesSection/CourseCard';
import { useAuthContext } from '../../context/AuthContext';
import { useWishlists } from '../../hooks/useWishlists';

export default function ProfileFavoritesPage() {
  const { isLoggedIn } = useAuthContext();
  const { items, loading, error, removeFromWishlist } = useWishlists({ enabled: isLoggedIn });
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(null), 3000);
    return () => window.clearTimeout(timer);
  }, [toast]);

  return (
    <>
      {toast && (
        <div
          role="status"
          className={`fixed left-1/2 top-6 z-[60] -translate-x-1/2 rounded-lg px-4 py-2.5 text-sm font-medium text-white shadow-lg ${
            toast.type === 'error' ? 'bg-red-600' : 'bg-[#2e7d32]'
          }`}
        >
          {toast.message}
        </div>
      )}

      <main className="rounded-2xl p-6 sm:px-0 sm:py-12">
        <div className="text-center">
          <h1 className="text-xl font-bold text-[#9369CC] sm:text-[32px]">
            All your favorite picks, saved in one place.
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-[20px] leading-relaxed text-[#666666]">
            Revisit important courses and lessons whenever you need.
          </p>
        </div>

        <div className="mt-8">
          {loading ? (
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {[1, 2, 3].map((item) => (
                <li key={item} className="h-[480px] animate-pulse rounded-2xl bg-white/70" />
              ))}
            </ul>
          ) : error ? (
            <p className="py-12 text-center text-sm text-red-600">{error}</p>
          ) : items.length > 0 ? (
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {items.map(({ wishlistId, course }) => (
                <li key={wishlistId || course.id}>
                  <CourseCard
                    course={course}
                    wishlistId={wishlistId}
                    onToggleFavorite={async (nextFav) => {
                      if (!nextFav) {
                        try {
                          await removeFromWishlist({ wishlistId, courseId: course.id });
                          setToast({ message: 'Removed from favorites', type: 'success' });
                        } catch (e) {
                          setToast({
                            message: e?.message || 'Failed to remove favorite',
                            type: 'error',
                          });
                          throw e;
                        }
                      }
                    }}
                  />
                </li>
              ))}
            </ul>
          ) : (
            <p className="py-16 text-center text-base text-[#666666]">
              No favorite courses yet. Tap the heart on a course to save it here.
            </p>
          )}
        </div>
      </main>
    </>
  );
}
